// extracted by mini-css-extract-plugin
module.exports = {"main":"Features_main__Ei3mg","features":"Features_features__3LVWs","feature":"Features_feature__107rh"};